import React from "react";
import OddEvenMobile from "./Statistic/OddEvenMobile";

const OddEvenTableMobile = (props) => {
    const { t } = props;

    return (
        <div className="rhm-card">
            <div className="rhm-card__title">
                {t("labels:keno.colorOddEven")}
            </div>

            <div className="rhm-card__body">
                <div className="rhm-table-wrap">
                    <table className="rhm-table">
                        <tbody>
                        <OddEvenMobile {...props} />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OddEvenTableMobile;